import React from "react";
import "./admission.css";
import { Link } from "react-router-dom";
import { useTypewriter,Cursor } from "react-simple-typewriter";
import { useEffect, useRef } from 'react';
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
gsap.registerPlugin(ScrollTrigger);

function Admission() {
  const ref = useRef();
  useEffect(() => {
      const el = ref.current;
      gsap.fromTo(el, {y:-150 ,opacity:0}, 
        {
          y:.1, duration:2,delay:1.5,opacity:1, scrollTrigger: {
              trigger: el,
          }
      })
  }, [])





  const [text]=useTypewriter({
    words:['"Carrier"','"Skills"','"Knowledge"','........'],
    loop:{},
    // typeSpeed:10
  })
  return (
    <div className="admission_container">
      <div className="admissoin_sub" ref={ref}>
        <div className="admisson_left">
          <h1>
            Admission <span style={{ color: "rgb(119,94,209)" }}>Open</span>
          </h1>
          <br />
          <p>
            VITS sets the benchmarks of global education with a system that
            matches the <br /> best practices, theories, resources, and
            standards all over the world. Come be <br />  part of university
            not only grooms leaders but also good human beings values. <br /> Lorem
            ipsum dolor sit met consectetur adipisicing elit. Deleniti atque
            possimus <br /> modi voluptaty accusantium qui similique id sapiente amet
            quia eligendi rerum <br /> deserunt dolorum vel quo corporis eum, fuga
            sint.
          </p>
          <br />
          <button className="left_container_btn">
            <Link>
              Apply Now &nbsp;<i className="fa fa-hand"></i>
            </Link>
          </button>
          <br /><br />
          <h2 className="admission_typing">Here your chance to grow your <span style={{color: "rgb(19,124,209)"}}>{text}</span></h2>
        </div>
        <div className="admission_right">
          <img
            src="https://img.freepik.com/premium-photo/portrait-male-student-standing-outside-front-college-buildingcreated-with-generative-ai-technology_132358-9084.jpg"
            alt=""
          />
        </div>
      </div>
    </div>
  );
}

export default Admission;
